export const mediaTypeSpm = [
  {
    name: 'ws',
    spm: '2001',
  },
  {
    name: 'kg',
    spm: '2018',
  },
  {
    name: 'txvideo',
    spm: '2017',
  },
  {
    name: 'om',
    spm: '2019',
  },
  {
    name: 'qq',
    spm: '2020',
  },
  {
    name: 'kdlive',
    spm: '2021',
  },
];
